var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestResult, RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
class MockResult extends RestResult {
  constructor(data, error) {
    super(data, "", 0);
    __publicField(this, "_mockData", null);
    __publicField(this, "_mockError", "");
    this._mockData = data;
    this._mockError = error;
  }
  ensureSuccess() {
    if (!this.isSuccessful()) {
      throw new Error(`The result wasn't successful: ${this._mockError}`);
    }
  }
  getSuccessData() {
    this.ensureSuccess();
    return this._mockData;
  }
  isSuccessful() {
    return !this._mockError;
  }
}
const getErrorMessage = (result) => {
  var _a;
  if (200 !== result.statusCode) {
    return (_a = result.errorContext) == null ? void 0 : _a.displayError;
  } else {
    return "";
  }
};
let ComputeResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.cms);
  }
  getComputeList(workspaceId, search) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/compute/query`;
      if (!!search) {
        address = `/workspaces/${workspaceId}/compute/query?filter=${search}`;
      }
      const result = yield this._get(address);
      return result;
    });
  }
  getCompute(workspaceId, name) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/compute/${name}`;
      const result = yield this._get(address);
      result.error = getErrorMessage(result);
      return result;
    });
  }
  postCompute(postParams) {
    return __async(this, null, function* () {
      const address = `/workspaces/${postParams.workspaceId}/compute`;
      const result = yield this._post(postParams, address);
      result.error = getErrorMessage(result);
      return result;
    });
  }
  putCompute(postParams) {
    return __async(this, null, function* () {
      const address = `/workspaces/${postParams.workspaceId}/compute`;
      const result = yield this._put(postParams, address);
      result.error = getErrorMessage(result);
      return result;
    });
  }
  deleteCompute(workspaceId, name) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/compute/${name}`;
      const result = yield this._delete(address);
      result.error = getErrorMessage(result);
      return result;
    });
  }
  postValidate(workspaceId, name) {
    return __async(this, null, function* () {
      const data = yield this.getCompute(workspaceId, name);
      const result = yield this.putCompute(data.getSuccessData().config);
      result.error = getErrorMessage(result);
      return result;
    });
  }
  mockCall(data, error) {
    return __async(this, null, function* () {
      const result = new MockResult(data, error);
      return result;
    });
  }
};
ComputeResource = __decorateClass([
  WPSProxyConverter()
], ComputeResource);
const ComputeResource$1 = new ComputeResource();
export {
  ComputeResource$1 as default
};
//# sourceMappingURL=Compute.resource.js.map
